var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneNavigationAppMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33,0H15c-2.7568359,0-5,2.2431641-5,5v38c0,2.7568359,2.2431641,5,5,5h18c2.7568359,0,5-2.2431641,5-5V5 C38,2.2431641,35.7568359,0,33,0z M15,2h18c1.6542969,0,3,1.3457031,3,3v35H12V5C12,3.3457031,13.3457031,2,15,2z M33,46H15 c-1.6542969,0-3-1.3457031-3-3v-1h24v1C36,44.6542969,34.6542969,46,33,46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2358398,24H22v3.7636719C22,28.9970703,23.0029297,30,24.2358398,30 c0.8525391,0,1.6191406-0.4736328,2.0004883-1.2363281l5.4873047-10.9746094C31.9042969,17.4272461,32,17.0224609,32,16.6181641 C32,15.1743164,30.8256836,14,29.3818359,14c-0.4042969,0-0.809082,0.0957031-1.1708984,0.2763672l-10.9755859,5.487793 C16.4736328,20.1455078,16,20.9121094,16,21.7641602C16,22.9970703,17.0029297,24,18.2358398,24z M18.1303711,21.5527344 l10.9750977-5.4873047C29.4956055,15.8676758,30.0004883,16.1816406,30,16.6181641 c0,0.0952148-0.0224609,0.190918-0.0654297,0.2763672l-5.4873047,10.9746094 C24.3496094,28.0654297,23.9990234,27.9833984,24,27.7636719V23c0-0.5522461-0.4477539-1-1-1h-4.7641602 C18.105957,22,18,21.894043,18,21.7641602C18,21.675293,18.0512695,21.5922852,18.1303711,21.5527344z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNavigationAppMedium);
export default __webpack_public_path__ + "static/media/phone-navigation-app--medium.f41ef6c5837bc589e8474d2c50571dee.svg";
export { ForwardRef as ReactComponent };